import React from "react";
import src from "./assets/images/2nd_anniversary_inside2.jpeg";
const Hero = () => (
  <img src={src} style={{ width: "100%", height: "50%", objectFit: "cover" }} alt="Clash Royale Trainer" />
);
export default Hero;
